<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
    name: "form-add-instruktur",
    props: ['idPembelajaran'],
    data() {
        return {
            instruktur_data: [],
            peserta_ref: [],
        };
    },
    mounted() { },
    methods: {
        addRowPeserta() {
            let self = this;
            self.instruktur_data.push({
                instruktur_data: ""
            });
        },
        deleteRow(index, row_data) {
            let self = this;
            var idx = self.instruktur_data.indexOf(row_data);
            if (idx > -1) {
                self.instruktur_data.splice(idx, 1);
            }
        },
        onSearchInstruktur(search, loading) {
            if (search.length) {
                loading(true);
                this.searchPeserta(loading, search, this);
            }
        },
        searchPeserta: function (loading, search) {
            let self = this;
            var config = {
                method: "get",
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/search-instruktur",
                params: {
                    search: search,
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };
            axios(config).then((response) => {
                if (response.data.meta.code == 200) {
                    self.peserta_ref = response.data.data.referensi;
                    loading(false);
                } else {
                    self.peserta_ref = [
                        {
                            user_id: 0,
                            username: "-",
                        },
                    ];
                    loading(false);
                }
            });
        },
        StoreData() {
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
            });

            const conf = {
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pra-pelaksanaan/instruktur",
                method: 'post',
                data: {
                    instrukturs: JSON.stringify(this.instruktur_data),
                    idPembelajaran: this.idPembelajaran
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token
                }
            }

            axios(conf).then(res => {
                console.log(res)
                Swal.fire({
                    icon: "success",
                    title: "Berhasil",
                    text: "Data berhasil di simpan.",
                    timer: 2000,
                    timerProgressBar: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                        Swal.close();
                        var dataDuplicate = []
                        if(res.data.data[0]){
                            dataDuplicate = res.data.data[0]
                        }

                        self.$emit("refresh-table", dataDuplicate);
                    }
                });
            })
        },
    },
};
</script>
<template>
    <b-form class="p-2" @submit.prevent="StoreData">
        <div class="row">
            <div class="col-12">
                <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
                    <thead class="bg-dark text-center text-white">
                        <tr>
                            <th style="width: 50px">No</th>
                            <th style="width: auto">Instruktur</th>
                            <th style="width: 50px" class="text-center">
                                <b-button type="button" class="btn btn-success btn-sm" v-on:click="addRowPeserta">
                                    <i class="fa fa-plus"></i>
                                </b-button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row_data, key_data) in instruktur_data" :key="key_data">
                            <td class="text-center">{{ key_data + 1 }}.</td>
                            <td>
                                <v-select label="nip_name" v-model="row_data.instruktur_data" :options="peserta_ref"
                                    @search="onSearchInstruktur" placeholder="Cari dan Pilih Instruktur...">
                                </v-select>
                            </td>
                            <td>
                                <div class="text-center">
                                    <div class="btn btn-sm btn-danger" v-on:click="deleteRow(key_data, row_data)">
                                        <i class="fa fa-minus"></i>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">&nbsp;</div>
            <!-- end col -->
            <div class="col-lg-6">
                <div class="text-end">
                    <b-button type="reset" variant="danger">
                        <i class="fa fa-redo-alt"></i> Reset
                    </b-button>
                    &nbsp;
                    <b-button type="submit" variant="primary">
                        <i class="fa fa-save"></i> Simpan
                    </b-button>
                </div>
            </div>
            <!-- end col -->
        </div>
    </b-form>
</template>
